import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import {
  DepositMethod,
  DepositMethodTextMap,
  DepositMethodUnitMap
} from '@eastcoal/shared/enums/DepositMethod'

import { DepositInputProps } from './interface'

const options = mapNumberEnumOptions(DepositMethodTextMap).filter(
  option => option.value === DepositMethod.SESSION_FIXED
)

const Component = ({ disabled, value = {}, onChange }: DepositInputProps) => {
  const handleSelectChange = (depositMethod: DepositMethod) => {
    onChange?.({
      ...value,
      depositMethod
    })
  }

  const handleInputChange = (depositValue: number | string | null) => {
    onChange?.({
      ...value,
      depositValue: isNil(depositValue) ? 0 : Number(depositValue)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.depositMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled}
        value={value.depositValue}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange}
      />
      {!isNil(value.depositMethod) && (
        <Space.Addon>{DepositMethodUnitMap[value.depositMethod]}</Space.Addon>
      )}
    </Space.Compact>
  )
}

export const DepositInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
